var _lyteUiComponentsLocale = {
	"lyte.calendar.previous.month": "Previous Month",
	"lyte.calendar.previous.year": "Previous Year",
	"lyte.calendar.next.month": "Next Month",
	"lyte.calendar.next.year": "Next Year",
	"lyte.calendar.choose.month": "Choose Month",
	"lyte.calendar.choose.year": "Choose Year",
	"lyte.calendar.monthview.drilldown.button": "Open a list of navigatable months",
	"lyte.calendar.decadeview.drilldown.button": "Open a list of navigatable years",
  "short.week": "W",
  "lyte.colorpicker.back": "back",
	"lyte.colorpicker.apply": "apply",
	"lyte.colorpicker.cancel": "cancel",
	"lyte.colorpicker.done": "done",
	"January": "January",
	"February": "February",
	"March": "March",
	"April": "April",
	"May": "May",
	"June": "June",
	"July": "July",
	"August": "August",
	"September": "September",
	"October": "October",
	"November":"November",
	"December":"December",
	"Jan": "Jan",
	"Feb": "Feb",
	"Mar": "Mar",
	"Apr": "Apr",
	"short.may": "May",
	"Jun": "Jun",
	"Jul": "Jul",
	"Aug": "Aug",
	"Sep": "Sep",
	"Oct": "Oct",
	"Nov": "Nov",
	"Dec": "Dec",
	"Mon": "Mon",
	"Tue": "Tue",
	"Wed": "Wed",
	"Thu": "Thu",
	"Fri": "Fri",
	"Sat": "Sat",
	"Sun": "Sun",
	"today": "Today",
  "monday": "Monday",
  "tuesday": "Tuesday",
  "wednesday": "Wednesday",
  "thursday": "Thursday",
  "friday": "Friday",
  "saturday": "Saturday",
  "sunday": "Sunday",
  "all-day": "All-Day",
  "day": "Day",
  "week": "Week",
  "month": "Month",
	"PM" : "PM",
  	"AM" : "AM",
  	"hour" : "hrs",
  	"min" : "mins",
  	"no.results.found": "No Results Found",
  	"Recently.Used.Colors": "Recently Used Colours",
	"Theme.Colors" : "Theme Colours",
	"Standard.Colors" : "Standard Colours",
	"Advanced.Colors" : "Advanced Colours",
	"Back.to.Basic.Colors" : "Back to Basic Colours",
	"Close" : "Close",
	"Available" : "Available",
 	"Selected" : "Selected",
 	"No.Fill" : "No Fill",
	"Choose.Color" : "Choose Colour",
	"Copy.Color.value.to.Clipboard" : "Copy the colour value to the clipboard",
	"yesterday" : 'Yesterday',
	"thisWeek" : 'This week',
	"thisMonth" : 'This month',
	"last7days" : "Last 7 days",
	"last30days" : "Last 30 days",
	"specificDate" : "Specific date",
	"customRange" : "Custom Range",
  "before" : "Before",
  "after" : "After",
	"Select" : 'Select',
	"lyte.fileupload.Drag file here or browse to upload": "Drag file here or browse to upload",
	"lyte.fileupload.Attachment failed": "Attachment failed",
	"lyte.fileupload.Retry": "Retry",
	"HEX" : "HEX",
	"RGB" : "RGB",
	"HSV" : "HSV",
	"CMYK" : "CMYK",
	"Alpha" : "Alpha",
  	"Color.value.copied" : "Colour value copied",
  	"lyte.nav.more.options": "More Options",
  	"lyte.avatar.navigator.previous.nav.button": "You are currently navigating a list of images. Previous Navigation.",
  	"lyte.avatar.navigator.next.nav.button": "You are currently navigating a list of images. Next Navigation.",
  	"lyte.avatar.navigator.previous.nav.description": "Press this to navigate to previous set of images",
  	"lyte.avatar.navigator.next.nav.description": "Press this to navigate to next set of images",
  	"lyte.avatar.navigator.description": "This has a set of images with navigatable buttons",
  	"lyte.avatar.navigator.images.shown": "Images $0 to $1 shown",
		"lyte.dual.listbox.no.results.found": "No Results Found",    
    "lyte.listview.true": "true",
    "lyte.listview.false": "false",
    "lyte.listview.search.placeholder": "Search here",
    "lyte.listview.filter": "Filter",
    "lyte.listview.filter.reset": "Reset",
    "lyte.listview.column.chooser": "Choose Columns",
    "lyte.listview.filter.not.selected": "Not Selected",
    "lyte.listview.filter.today": "Today",
    "lyte.listview.filter.till.yesterday": "Till Yesterday",
    "lyte.listview.filter.tomorrow": "Tomorrow",
    "lyte.listview.filter.next.7.days": "Next 7 Days",
    "lyte.listview.filter.last.week": "Last Week",
    "lyte.listview.filter.last.month": "Last Month",
    "lyte.listview.filter.is": "Is",
    "lyte.listview.filter.not.is": "Is not",
    "lyte.listview.filter.between": "Between",
    "lyte.listview.filter.less.than": "Less than",
    "lyte.listview.filter.greater.than": "Greater than",
    "lyte.listview.filter.less.than.or.equal": "Greater than",
    "lyte.listview.filter.greater.than.or.equal": "Greater than",
    "lyte.listview.filter.not.between": "Not between",
    "lyte.listview.filter.is.empty": "Is empty",
    "lyte.listview.filter.is.not.empty": "Is not empty",
    "lyte.listview.filter.set": "Set",
    "lyte.listview.filter.not.set": "Not set",
    "lyte.listview.filter.bigins": "Starts with",
    "lyte.listview.filter.contains": "Contains",
    "lyte.note.upload.file": "File Upload",
    "lyte.note.storage": "Storage",
    "lyte.note.more": "More",
    "lyte.note.add.note": "Add a note",
    "lyte.note.attach.files": "Attach Files",
    "lyte.note.all": "All",
    "lyte.note.discard": "Discard",
    "lyte.note.delete": "Delete",
    "lyte.listview.true": "true",
    "lyte.listview.false": "false",
    "lyte.listview.search.placeholder": "Search here",
    "lyte.listview.filter": "Filter",
    "lyte.listview.filter.reset": "Reset",
    "lyte.listview.column.chooser": "Choose Columns",
    "lyte.listview.filter.not.selected": "Not Selected",
    "lyte.listview.filter.today": "Today",
    "lyte.listview.filter.till.yesterday": "Till Yesterday",
    "lyte.listview.filter.tomorrow": "Tomorrow",
    "lyte.listview.filter.next.7.days": "Next 7 Days",
    "lyte.listview.filter.last.week": "Last Week",
    "lyte.listview.filter.last.month": "Last Month",
    "lyte.listview.filter.is": "Is",
    "lyte.listview.filter.not.is": "Is not",
    "lyte.listview.filter.between": "Between",
    "lyte.listview.filter.less.than": "Less than",
    "lyte.listview.filter.greater.than": "Greater than",
    "lyte.listview.filter.less.than.or.equal": "Greater than",
    "lyte.listview.filter.greater.than.or.equal": "Greater than",
    "lyte.listview.filter.not.between": "Not between",
    "lyte.listview.filter.is.empty": "Is empty",
    "lyte.listview.filter.is.not.empty": "Is not empty",
    "lyte.listview.filter.set": "Set",
    "lyte.listview.filter.not.set": "Not set",
    "lyte.listview.filter.bigins": "Starts with",
    "lyte.listview.filter.contains": "Contains",
    "lyte.note.upload.file": "File Upload",
    "lyte.note.storage": "Storage",
    "lyte.note.more": "More",
    "lyte.note.add.note": "Add a note",
    "lyte.note.attach.files": "Attach Files",
    "lyte.note.all": "All",
    "lyte.note.discard": "Discard",
    "lyte.note.delete": "Delete",
    "lyte.listview.true": "true",
    "lyte.listview.false": "false",
    "lyte.listview.search.placeholder": "Search here",
    "lyte.listview.filter": "Filter",
    "lyte.listview.filter.reset": "Reset",
    "lyte.listview.column.chooser": "Choose Columns",
    "lyte.listview.filter.not.selected": "Not Selected",
    "lyte.listview.filter.today": "Today",
    "lyte.listview.filter.till.yesterday": "Till Yesterday",
    "lyte.listview.filter.tomorrow": "Tomorrow",
    "lyte.listview.filter.next.7.days": "Next 7 Days",
    "lyte.listview.filter.last.week": "Last Week",
    "lyte.listview.filter.last.month": "Last Month",
    "lyte.listview.filter.is": "Is",
    "lyte.listview.filter.not.is": "Is not",
    "lyte.listview.filter.between": "Between",
    "lyte.listview.filter.less.than": "Less than",
    "lyte.listview.filter.greater.than": "Greater than",
    "lyte.listview.filter.less.than.or.equal": "Greater than",
    "lyte.listview.filter.greater.than.or.equal": "Greater than",
    "lyte.listview.filter.not.between": "Not between",
    "lyte.listview.filter.is.empty": "Is empty",
    "lyte.listview.filter.is.not.empty": "Is not empty",
    "lyte.listview.filter.set": "Set",
    "lyte.listview.filter.not.set": "Not set",
    "lyte.listview.filter.bigins": "Starts with",
    "lyte.listview.filter.contains": "Contains",
    "lyte.note.upload.file": "File Upload",
    "lyte.note.storage": "Storage",
    "lyte.note.more": "More",
    "lyte.note.add.note": "Add a note",
    "lyte.note.attach.files": "Attach Files",
    "lyte.note.all": "All",
    "lyte.note.discard": "Discard",
    "lyte.note.delete": "Delete",
    "lyte.listview.filter.greater.than.or.equal": "Greater than or equal to",
    "lyte.listview.filter.less.than.or.equal": "Less than or equal to",
    "lyte.codesnippet.copy": "Copy",
    "lyte.codesnippet.failure.message": "Unable to copy",
    "lyte.codesnippet.success.message": "Copied",
    "lyte.video.play" : "Play",
    "lyte.video.pause" : "Pause",
    "lyte.video.skip.forward" : "Forward",
    "lyte.video.skip.backward" : "Backward",
    "lyte.video.volume.mute" : "Mute",
    "lyte.video.volume.unmute" : "Unmute",
    "lyte.video.settings" : "Settings",
    "lyte.video.mode.pip" : "Play Picture in Picture",
    "lyte.video.mode.fullScreen" : "Full Screen",
    "lyte.video.menu.subtitles.off" : "off",
    "lyte.video.menu.subtitles" : "Subtitles/CC",
    "lyte.video.menu.playBackSpeed" : "Playback Speed",
    "lyte.video.menu.qualityOption" : "Quality",
    "lyte.video.menu.qualityOption.auto" : "auto",
    "lyte.checkbox.on": "on",
	  "lyte.checkbox.off": "off"
};
